import { render, staticRenderFns } from "./CorrectionCard.vue?vue&type=template&id=ff4c3b6a&scoped=true&lang=html&"
import script from "./CorrectionCard.vue?vue&type=script&lang=js&"
export * from "./CorrectionCard.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionCard.vue?vue&type=style&index=0&id=ff4c3b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4c3b6a",
  null
  
)

export default component.exports